import { render, staticRenderFns } from "./PerformanceStats.vue?vue&type=template&id=02065caa"
import script from "./PerformanceStats.vue?vue&type=script&lang=js"
export * from "./PerformanceStats.vue?vue&type=script&lang=js"
import style0 from "./PerformanceStats.vue?vue&type=style&index=0&id=02065caa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports